"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createWapp;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _utils = require("./utils.js");
var _config = _interopRequireDefault(require("./config"));
var _excluded = ["containerElementId", "appStateName", "siteName", "description", "lang"];
function createWapp() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _getConfig = (0, _config["default"])(p),
    _getConfig$config = _getConfig.config,
    config = _getConfig$config === void 0 ? {} : _getConfig$config;
  var commonConfig = config.common;
  var globalConfig = config.globals;
  var containerElementId = commonConfig.containerElementId,
    appStateName = commonConfig.appStateName,
    siteName = commonConfig.siteName,
    description = commonConfig.description,
    lang = commonConfig.lang,
    rest = (0, _objectWithoutProperties2["default"])(commonConfig, _excluded);
  var defaultConfig = Object.create(Object.prototype, {
    containerElementId: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: containerElementId
    }),
    appStateName: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: appStateName
    }),
    siteName: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: siteName
    }),
    description: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: description
    }),
    lang: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: lang
    })
  });
  (0, _utils.mergeProperties)(defaultConfig, rest);
  var defaultGlobals = Object.create(Object.prototype, {
    DEV: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: globalConfig.DEV
    }),
    RUN: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: globalConfig.RUN
    }),
    WAPP: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: globalConfig.WAPP
    }),
    TYPE: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: globalConfig.TYPE
    }),
    ROOT: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: globalConfig.ROOT
    }),
    NAME: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: globalConfig.NAME
    })
  });
  var defaultTarget = "undefined" == typeof window ? "node" : "web";
  var defaultGetTargetObject = function defaultGetTargetObject() {
    var target = wapp.target === "node" ? "server" : "client";
    return wapp[target];
  };
  var wapp = Object.create(Object.prototype, {
    config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultConfig
    }),
    globals: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultGlobals
    }),
    target: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultTarget
    }),
    getTargetObject: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultGetTargetObject
    })
  });
  Object.defineProperty(wapp, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  return wapp;
}